// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--2tp27","Sider":"Sider--2hPl_","HugeText":"HugeText--1T0oI","Content":"Content--2y0Ts","Alert":"Alert--3uNk1"};